import {HttpClient, HttpContext} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ProfileOverviewUser} from '@gatewee/types/profile-overview';
import {Observable} from 'rxjs';
import {SKIP_SPINNER} from './tokens/spinner.token';

@Injectable({
  providedIn: 'root',
})
export class ProfileOverviewService {
  constructor(private readonly http: HttpClient) {}

  getProfile(): Observable<ProfileOverviewUser> {
    return this.http.get<ProfileOverviewUser>('/auth/profile', {
      context: new HttpContext().set(SKIP_SPINNER, true),
    });
  }
}
